import { getYear, getMonth, getDate, getHours, getMinutes } from 'date-fns';
import getDateFromUnixTime from '@framework/date-helpers/getDateFromUnixTime';
import getUnixTimestamp from '@framework/date-helpers/getUnixTimestamp';
import getZonedUTCDate from '@framework/date-helpers/getZonedUTCDate';
import { ICallDetailsFormValues } from '../interfaces';
import { ICallDetails } from '@evercall/domain/vo/call/CallDetails';
import { mapOptionToValue } from '@framework/data-helpers/selectOptionMappers';
import CallEvent from '@evercall/domain/CallEvent';
import { CallEventType } from '@evercall/domain/vo/call/CallEventType';
import { DialInCountriesArrayItemCountryFor } from '@evercall/domain/vo/call/DialInCountriesArrayItem';

export const getCallDetailsSubmitPayload = (
  values: ICallDetailsFormValues,
): ICallDetails => {
  const {
    name,
    eventTypeId,
    dateAt: dateAtUnix,
    timeAt: timeAtUnix,
    timeZoneId,
    transactionTypeId,
    estimatedDuration,
    approximateNumberOfParticipants,
    dialInCountries,
  } = values;
  const isMeeting = CallEvent.isMeeting(mapOptionToValue(eventTypeId) as CallEventType);
  const dateAt = getDateFromUnixTime(dateAtUnix);
  const timeAt = getDateFromUnixTime(timeAtUnix);
  return {
    name,
    transactionTypeId: mapOptionToValue(transactionTypeId) as string,
    estimatedDuration: parseInt(estimatedDuration),
    dateTime: getUnixTimestamp(getZonedUTCDate(
      timeZoneId.timeZone,
      new Date(
        getYear(dateAt),
        getMonth(dateAt),
        getDate(dateAt),
        getHours(timeAt),
        getMinutes(timeAt),
      ),
    )),
    timeZoneId: mapOptionToValue(timeZoneId) as string,
    approximateNumberOfParticipants: parseInt(approximateNumberOfParticipants),
    ...(!isMeeting && {
      dialInCountries: dialInCountries
        .filter((dialIn) => !!dialIn.countryId)
        .map((dialIn) => (
          {
            countryId: mapOptionToValue(dialIn.countryId) as string,
            countryFor: mapOptionToValue(dialIn.countryFor) as DialInCountriesArrayItemCountryFor,
            countryDisplay: dialIn.countryDisplay,
          }
        )),
    }),
  };
};

export default getCallDetailsSubmitPayload;
